<template>
	<div class="points-details" v-if="dataList && dataList.length">
		<div class="list" v-for="(item,index) in dataList" :key="index">
			<div class="list-m">
					<!-- <h3 class="line1" style="width:800px;" v-if="item.integralName">{{item.integralName}}</h3> -->
				<div class="list-tips text-opacity">
					<span>{{item.integralName}}获取{{item.integralNum}}积分</span>
				</div>
			</div>
		</div>
		<Pagination :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange" />
	</div>
	<Empty v-else content="暂未数据" />
</template>

<script>
import qs from 'qs'
import { post,ajaxParam } from '@/units/request.js'
import Pagination from '@/components/pagination'
import Empty from '@/components/empty'
	export default {
		name: 'publicItem',
		components: {
			Pagination,
			Empty
		},
		data() {
			return {
				dataList:[ 					
					{title:'首次完善个人记录',content:'完善个人记录获取10分级'}, 					
					{title:'浏览帖子大于10s',content:'浏览一个帖子，获取到10积分'},	 					
					{title:'您刚发布了一条帖子',content:'发布新帖子获取10积分'},	 					
					{title:'评论帖子',content:'您评论了帖子获取10积分'},	 					
					{title:'点赞帖子',content:'您点赞了帖子获取10积分'},	 					
					{title:'帖子被加入精选',content:'帖子加入精选获取10积分'},	 				
				],
				pageSize: 10,
				pageNum: 1,
				total: 0
			}
		},
		created() {
			this.userId = localStorage.getItem('userId') || ''
			this.getDataList()
		},
		methods: {
			//获取数据列表
			async getDataList(){
				let param = {
					userId: this.userId,
					pageSize: this.pageSize,
					pageNum: this.pageNum
				}
				ajaxParam(param)
				const res = await post('v1/integral/getUserIntegralHistory', qs.stringify(param))
				if(res.data.code==200){
					console.log(res.data.page.items)
					this.dataList = res.data.page.items
					this.total = res.data.page.count
				} else {
					this.$message.error(res.data.msg)
				}
			},
			pageChange(e) {
					this.dataList = []
					this.pageNum = e.number
					this.getDataList()
			},
		}
	}
</script>

<style scoped lang="less">
	.points-details{
		background: #fff;
		padding: 16px;
	}
	.list{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 20px 0;
		border-bottom: 1px solid var(--color-border);
		.list-m{
			width:0;
			flex: 1;
			h3{
				margin-top: 5px;
				font-weight: bold;
				font-size: 16px;
				line-height: 27px;
			}
			.list-tips{
				font-size: 15px;
				padding: 6px 0 12px;
			}
		}
	}
</style>
